<template>
  <div class="order-idle">
    <div class="order-idle__content">
      <div class="idle-icon" v-if="icon">
        <SvgIcon height="32" width="32" icon="ScheduledOrder" />
      </div>
      <div class="order-idle__content__text">
        <div>{{ title }}</div>
        <span>{{ desc }}</span>
      </div>
    </div>
    <div v-if="button" class="order-idle__btn" @click="handleClickButton">
      <span>{{ buttonLabel }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Idle',
  props: {
    title: {
      type: String
    },
    desc: {
      type: String
    },
    icon: {
      type: Boolean,
      default: false
    },
    button: {
      type: Boolean,
      default: false
    },
    buttonLabel: {
      type: String
    },
    onClickButton: {
      type: Function
    }
  },
  methods: {
    handleClickButton() {
      this.$emit('onClickButton')
    }
  }
}
</script>

<style lang="scss" scoped>
.order-idle {
  font-size: 14px;
  min-height: 72px;
  width: 100%;
  display: grid;
  grid-auto-flow: column;
  grid-template-columns: 1fr auto;
  align-items: center;

  .idle-icon {
    margin-right: 12px;
    margin-top: 4px;
  }

  .order-idle__content {
    flex: 1;
    padding: 16px;
    display: flex;
    align-items: center;

    .order-idle__content__text {
      > div {
        color: #1a1a1a;
        font-weight: 500;
      }

      > span {
        color: #7a8189;
      }
    }
  }

  .order-idle__btn {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    border-left: 1px solid #f2f2f2;
    color: #ff8200;
    font-weight: 500;
    cursor: pointer;
    width: 86px;
    text-align: center;

    &:hover {
      background-color: #f8f8f8;
      border-top-right-radius: 8px;
      border-bottom-right-radius: 8px;
    }
  }
}
</style>
